<script setup lang="ts">
import { computed, ref, useId } from "vue"

interface ExpandableProps {
  initialOpen?: boolean
}

const props = withDefaults(defineProps<ExpandableProps>(), {
  initialOpen: false,
})

const isOpen = ref<boolean>(props.initialOpen)
const baseId = useId()

const triggerId = computed(() => `expandable-trigger-${baseId}`)
const contentId = computed(() => `expandable-content-${baseId}`)

const activatorAttrs = computed(() => ({
  "id": triggerId.value,
  "type": "button" as const,
  "aria-expanded": isOpen.value,
  "aria-controls": contentId.value,
}))

function toggle() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <slot name="activator" v-bind="{ toggle, isOpen, activatorAttrs }" />
  <div
    :id="contentId"
    role="region"
    :aria-labelledby="triggerId"
    :aria-hidden="!isOpen"
    :inert="!isOpen || undefined"
    class="grid transition-[grid-template-rows] duration-250 ease-in-out"
    :class="isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
  >
    <div class="overflow-y-hidden">
      <slot />
    </div>
  </div>
</template>
